import React from "react";
import { SubCategory, CategoryPoint } from "../../../types";
import { ArrowRightCircle } from "lucide-react";
import ServiceCategoryRowGallery from "./ServiceCategoryRowGallery";
import ContentTitles from "../../typography/content-titles/ContentTitles";
import { useResizeHook } from "../../../lib";

type ServiceCategoryRowProps = {
    category: SubCategory;
    showPoints: boolean;
    dark: boolean;
    overlineTitle: string;
};

export default function ServiceCategoryRowContent({
                                                      category,
                                                      overlineTitle,
                                                      dark,
                                                      showPoints
                                                  }: ServiceCategoryRowProps) {

    const { greaterThanTailwindLg1024 } = useResizeHook();

    const localTheme = dark
        ? {
            background: "var(--alt-bg)",
            color: "#FFF"
        }
        : {
            background: "var(--main-bg)",
            color: "var(--main-color)"
        };

    const { title, description, slug, headCategory, points, images, link } = category;

    const renderPointIcon = (icon: CategoryPoint["icon"]) => {
        if (!icon) return null;
        if (React.isValidElement(icon)) return icon;

        const Icon = icon as React.ElementType;
        return <Icon className="h-5 w-5" />;
    };

    return (
        <div className="lg:col-span-4 md:col-span-12 col-span-12">
            <div>
                {!!overlineTitle?.length && (
                    <div className="mb-2"><ContentTitles
                    overline={`${overlineTitle}`}
                    /></div>)}

                <div className="pb-8">
                    {!!title?.length && (
                        <ContentTitles
                        title={`${title}`}
                        titleComponent='h2'
                        id={slug}
                    />)}
                </div>

            </div>

            {!greaterThanTailwindLg1024 && <ServiceCategoryRowGallery images={images} />}

                <div>
                    <h5 className="text-left md:text-center md:text-sm py-5" >
                        {description}
                    </h5>
                </div>

            {showPoints && (
                <div
                    className="
                        pt-4
                        items-center
                        md:py-1
                        lg:grid
                        lg:grid-cols-3
                        lg:gap-1
                    "
                >
                    {(points || []).map((point: CategoryPoint, i: number) => (
                        <div key={i}>
                            <div
                                className="
                                    flex items-center w-full
                                    pb-6 pt-0
                                    md:text-left md:items-center justify-center
                                    gap-2
                                    sm:flex  sm:pt-3 sm:m-0 sm:p-0
                                "
                            >
                                {renderPointIcon(point.icon)}

                                <div className="ml-1 sm:ml-0">
                                    <h6
                                        className="text-left sm:text-sm"
                                    >
                                        {point.title}
                                    </h6>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <div className="text-left md:text-center w-full">
                <a
                    href={`${link}`}
                    className={`
                        flex
                        items-center gap-2 mt-5 px-5 py-2 border rounded 
                        transition-all duration-200
                        hover:bg-gray-100
                        w-max
                        mx-auto
                        lg:bg-[${localTheme.background}] 
                        lg:text-[${localTheme.color}]
                    `}
                >
                    <ArrowRightCircle className="w-5 h-5" />
                    {title}
                </a>
            </div>
        </div>
    );
}
